import { createSelector } from 'reselect'

import { EMPTY_ARRAY } from 'utils/emptyConstants'

const selectData = (state) => state.settings.simulator.self.data
const selectLoader = (state) => state.settings.simulator.self.loader
const selectError = (state) => state.settings.simulator.self.error
const selectRecipientList = (state) => state.settings.simulator.self.recipientList
const selectTagsData = (state) => state.settings.simulator.self.tags
const selectCandidatesData = (state) => state.settings.simulator.self.candidates
const selectTags = createSelector(selectTagsData, (tags) =>
  // tags.data is the tag list; guard against a missing/malformed payload
  // (e.g. an empty/error envelope) so the dropdown degrades to "no tags"
  // instead of crashing the whole Simulator settings page on `.reduce`.
  (tags?.data || EMPTY_ARRAY).reduce((acc, elem) => {
    if (elem.id !== -1) {
      acc.push({ value: elem.id, label: elem.name })
    }

    return acc
  }, [])
)
const selectCandidates = createSelector(selectCandidatesData, (candidates) =>
  // candidates.data.items is the recipient list; guard against a
  // missing/malformed payload so it degrades to "no candidates" instead of
  // crashing on `.map`.
  (candidates?.data?.items || EMPTY_ARRAY).map(({ id, fullName, type }) => ({
    label: fullName,
    value: id,
    type,
  }))
)

export {
  selectData,
  selectLoader,
  selectError,
  selectRecipientList,
  selectTags,
  selectTagsData,
  selectCandidates,
  selectCandidatesData,
}
